function updateMaterialParam(id) {
  if ('URLSearchParams' in window) { // doesn't work in IE
    const searchParams = new URLSearchParams(window.location.search);
    let newPath = window.location.pathname;
    if (id === "js_all") {
      searchParams.delete("material");
    } else {
      searchParams.set("material", id);
      newPath += `?${searchParams.toString()}`;
    }
    window.history.replaceState(null, '', newPath);
  }
}

function toggleMaterialFilter(id, reviews, filterSelectors) {
  const materialIds = ["js_aluminum", "js_wood_mounted", "js_face_mounted_acrylic"];

  // toggle visibility of reviews based on material filter
  if (id === "js_all") {
    reviews.forEach(el => { el.style.display = "block"; });
    updateMaterialParam(id);
  } else if (materialIds.includes(id)) {
    reviews.forEach(el => {
      if (el.classList.contains(id)) {
        el.style.display = "block";
      } else {
        el.style.display = "none";
      }
    });
    updateMaterialParam(id);
  }

  // update class of selected filter to show underline
  // checking id before we remove selected since the handler is on the parent
  // element and if the user doesn't click on an li we don't want selected to
  // change
  if (materialIds.includes(id) || id === "js_all") {
    filterSelectors.forEach(el => {
      if (el.id === id) {
        el.classList.add("selected");
      } else {
        el.classList.remove("selected");
      }
    });
  }

  // update avg review info by material
  if (materialIds.includes(id) || id === "js_all") {
    document.getElementById("js_avg_review_by_material").innerHTML =
      window.rambleMaps.avgReviews[id].average;
    document.getElementById("js_avg_review_count").innerHTML =
      window.rambleMaps.avgReviews[id].count;
  }
}

export default function initReviews() {
  // init handlers to filter reviews by material on reviews page
  const materialFilter = document.getElementById("js_material_filter");
  const reviews = document.querySelectorAll(".review");
  if (materialFilter) {
    const filterSelectors = materialFilter.querySelectorAll("button");
    if (reviews) {
      materialFilter.addEventListener("click", ({ target }) => {
        toggleMaterialFilter(target.id, reviews, filterSelectors);

        window.gtag("event", "filterReviewsByMaterial", {
          event_category: "engagement",
          event_label: target.id
        });
      });
    }

    // read material filters from query parameters
    if ('URLSearchParams' in window) { // doesn't work in IE
      const searchParams = new URLSearchParams(window.location.search);
      const filteredMaterial = searchParams.get("material");
      if (filteredMaterial) {
        toggleMaterialFilter(filteredMaterial, reviews, filterSelectors);
      }
    }
  }
}
